/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */
import PropTypes from "prop-types";

import React, {
	PureComponent
} from "react";
import {
	View,
	StyleSheet
} from "react-native";

import OutputForm from "./OutputForm";
import StyledButton from "ae-base/Base/StyledButton";
import Style from "ae-style";

import xtend from "xtend";

var styles = StyleSheet.create({
	buttonContainer: {
		alignItems: "flex-end"
	},
	collapse: {
		paddingHorizontal: Style.layout.paddingSmall
	}
});

export default class OutputCollapsable extends PureComponent {
	constructor(props){
		super(props);
		this.state = {
			collapse: !props.contrast
		};
		this.collapse = toggleCollapse.bind(this);
	}
	render(){
		var props = this.props;
		var context = this.context;
		var schema = props.schema;
		var data = props.data;

		var localize = context.localize;

		var displaying = this.state.collapse;

		var showmore = localize("summarized.showmore");
		var showless = localize("summarized.showless");

		var icon = displaying ? "dropdown" : "directup";
		var title = displaying ? showmore : showless;

		var showableSchema = schema;
		var showableData = data;
		if(!showableData) return null;
		if(displaying){
			var properties = schema.properties;
			var newProperties = reduceData(properties, properties);
			showableSchema = xtend(showableSchema, {
				properties: newProperties
			});
			showableData = reduceData(properties, data);
		}

		return(
			<View style={styles.collapse}>
				<OutputForm schema={showableSchema} data={showableData} contrast={props.contrast} />
				<View style={styles.buttonContainer}>
					<StyledButton id={props.id} title={title} clear icon={icon} onPress={this.collapse} contrast={props.contrast} black={!props.contrast} />
				</View>
			</View>
		);
	}
}

function toggleCollapse(){
	this.setState({
		collapse: !this.state.collapse
	});
}

function reduceData(properties, data){
	return Object.keys(properties).reduce(function(acc, property){
		if(properties[property].summarize && data)
			acc[property] = data[property];
		return acc;
	}, {});
}

OutputCollapsable.contextTypes = {
	localize: PropTypes.func
};